<template>
  <div>
    <div class="p-4 flex flex-col gap-2 rounded-2xl bg-slate-200">
      <div class="flex items-center justify-between">
        <BlTextSubtitle2 :text="sectionName" class="text-slate-800" />
        <BlInputButton
          icon="edit"
          type="plain"
          @clicked="editOpened = true"
          title="Edit section"
        />
      </div>
      <div class="flex flex-col gap-1">
        <BlTextBody2 text="Mother's health condition" />
        <BlTextBody2
          :text="additional['mother_health_condition'] || '-'"
          class="text-slate-1000"
        />
      </div>
      <div class="flex flex-col gap-1">
        <BlTextBody2 text="Fetal health condition" />
        <BlTextBody2
          :text="additional['fetal_health_condition'] || '-'"
          class="text-slate-1000"
        />
      </div>
      <div class="flex flex-col gap-1">
        <BlTextBody2 text="Prenatal diagnosis" />
        <BlTextBody2
          :text="additional['prenatal_diagnosis'] || '-'"
          class="text-slate-1000"
        />
      </div>
      <div class="flex flex-col gap-1">
        <BlTextBody2 text="Gestational age at delivery" />
        <BlTextBody2
          :text="additional['gestational_age_at_delivery'] || '-'"
          class="text-slate-1000"
        />
      </div>
      <div class="flex flex-col gap-1">
        <BlTextBody2 text="Birth process" />
        <BlTextBody2
          :text="additional['birth_process'] || '-'"
          class="text-slate-1000"
        />
      </div>
      <div class="flex flex-col gap-1">
        <BlTextBody2 text="Birth complications" />
        <BlTextBody2
          :text="additional['birth_complications'] || '-'"
          class="text-slate-1000"
        />
      </div>
      <div class="flex flex-col gap-1">
        <BlTextBody2 text="Baby's weight at birth (kg)" />
        <BlTextBody2
          :text="additional['baby_weight_at_birth_kg'] || '-'"
          class="text-slate-1000"
        />
      </div>
      <div class="flex flex-col gap-1">
        <BlTextBody2 text="Baby's length at birth (cm)" />
        <BlTextBody2
          :text="additional['baby_length_at_birth_cm'] || '-'"
          class="text-slate-1000"
        />
      </div>
      <div class="flex flex-col gap-1">
        <BlTextBody2 text="Immediate crying at birth" />
        <BlTextBody2
          :text="additional['immediate_crying_at_birth'] || '-'"
          class="text-slate-1000"
        />
      </div>
      <div class="flex flex-col gap-1">
        <BlTextBody2 text="Skin color at birth" />
        <BlTextBody2
          :text="additional['skin_color_at_birth'] || '-'"
          class="text-slate-1000"
        />
      </div>
    </div>
    <div
      id="edit-client-information-panel"
      class="fixed w-screen right-0 flex justify-end transition-all duration-500"
      :style="{
        top: editOpened ? 'calc(4.5rem + 5rem)' : 'calc(100vh)',
        height: 'calc(100vh - 4.5rem - 5rem)',
        zIndex: 53
      }"
    >
      <div
        class="h-full w-screen absolute left-0 top-0 -z-10"
        @click="editOpened = false"
      ></div>
      <div class="h-full w-120 flex-shrink-0 flex flex-col relative z-0">
        <div
          class="relative h-full flex flex-col justify-between bg-pure-white overflow-y-auto"
        >
          <div class="px-6 flex flex-col">
            <div class="sticky top-0 z-10 py-3 bg-pure-white mb-0">
              <BlTextSubtitle2
                :text="`Edit ${sectionName}`"
                class="text-slate-800"
              />
            </div>
            <div class="flex flex-col gap-3">
              <BlInputText
                :input="motherHealthConditionInput"
                @changed="inputHandler"
              />
              <BlInputText
                :input="fetalHealthConditionInput"
                @changed="inputHandler"
              />
              <BlInputText
                :input="prenatalDiagnosisInput"
                @changed="inputHandler"
              />
              <BlInputText
                :input="gestationalAgeAtDeliveryInput"
                @changed="inputHandler"
              />
              <BlInputText :input="birthProcessInput" @changed="inputHandler" />
              <BlInputText
                :input="birthComplicationsInput"
                @changed="inputHandler"
              />
              <BlInputText
                :input="babyWeightAtBirthInput"
                @changed="inputHandler"
              />
              <BlInputText
                :input="babyLengthAtBirthInput"
                @changed="inputHandler"
              />
              <BlInputText
                :input="immediateCryingAtBirthInput"
                @changed="inputHandler"
              />
              <BlInputText
                :input="skinColorAtBirthInput"
                @changed="inputHandler"
              />
            </div>
          </div>
          <div
            class="h-18 px-6 pt-4 sticky bottom-0 flex-shrink-0 bg-pure-white grid grid-cols-2 gap-4"
          >
            <BlInputButton
              label="Close"
              type="plain"
              @clicked="editOpened = false"
            />
            <BlInputButton
              label="Update"
              :loading="submitLoading"
              @clicked="onUpdate"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

import BlTextSubtitle2 from "../../../../BlTextSubtitle2.vue";
import BlTextBody2 from "../../../../BlTextBody2.vue";
import BlInputText from "../../../../BlInputText.vue";
import BlInputButton from "../../../../BlInputButton.vue";

export default {
  name: "PregnancyAndBirthSection",
  components: {
    BlTextSubtitle2,
    BlTextBody2,
    BlInputText,
    BlInputButton
  },
  data() {
    return {
      sectionName: "Pregnancy and birth information",
      editOpened: false,
      submitLoading: false,
      motherHealthConditionInput: {
        label: "Mother's health condition",
        model: ""
      },
      fetalHealthConditionInput: { label: "Fetal health condition", model: "" },
      prenatalDiagnosisInput: { label: "Prenatal diagnosis", model: "" },
      gestationalAgeAtDeliveryInput: {
        label: "Gestational age at delivery",
        model: ""
      },
      birthProcessInput: { label: "Birth process", model: "" },
      birthComplicationsInput: { label: "Birth complications", model: "" },
      babyWeightAtBirthInput: {
        label: "Baby's weight at birth (kg)",
        model: ""
      },
      babyLengthAtBirthInput: {
        label: "Baby's length at birth (cm)",
        model: ""
      },
      immediateCryingAtBirthInput: {
        label: "Immediate crying at birth",
        model: ""
      },
      skinColorAtBirthInput: { label: "Skin color at birth", model: "" }
    };
  },
  computed: {
    ...mapGetters(["prospectInformation"]),
    additional() {
      return this.prospectInformation.additional_information || {};
    }
  },
  watch: {
    editOpened(val) {
      // prettier-ignore
      if (val) {
        this.motherHealthConditionInput.model = this.additional["mother_health_condition"];
        this.fetalHealthConditionInput.model = this.additional["fetal_health_condition"];
        this.prenatalDiagnosisInput.model = this.additional["prenatal_diagnosis"];
        this.gestationalAgeAtDeliveryInput.model = this.additional["gestational_age_at_delivery"];
        this.birthProcessInput.model = this.additional["birth_process"];
        this.birthComplicationsInput.model = this.additional["birth_complications"];
        this.babyWeightAtBirthInput.model = this.additional["baby_weight_at_birth_kg"];
        this.babyLengthAtBirthInput.model = this.additional["baby_length_at_birth_cm"];
        this.immediateCryingAtBirthInput.model = this.additional["immediate_crying_at_birth"];
        this.skinColorAtBirthInput.model = this.additional["skin_color_at_birth"];
      }
    }
  },
  methods: {
    ...mapActions(["updateProspect"]),
    displayDate(date, format) {
      if (!date) return "-";
      return moment(date).format(format);
    },
    inputHandler(payload) {
      payload.input.model = payload.value;
    },
    onUpdate() {
      // prettier-ignore
      const data = {
        id: this.prospectInformation.id,
        prospect: {
          additional_information: {
            mother_health_condition: this.motherHealthConditionInput.model,
            fetal_health_condition: this.fetalHealthConditionInput.model,
            prenatal_diagnosis: this.prenatalDiagnosisInput.model,
            gestational_age_at_delivery: this.gestationalAgeAtDeliveryInput.model,
            birth_process: this.birthProcessInput.model,
            birth_complications: this.birthComplicationsInput.model,
            baby_weight_at_birth_kg: this.babyWeightAtBirthInput.model,
            baby_length_at_birth_cm: this.babyLengthAtBirthInput.model,
            immediate_crying_at_birth: this.immediateCryingAtBirthInput.model,
            skin_color_at_birth: this.skinColorAtBirthInput.model
          },
          section_name: this.sectionName
        }
      };
      this.submitLoading = true;
      this.updateProspect(data).then(({ success }) => {
        this.submitLoading = false;
        if (!success) return;
        this.editOpened = false;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/salesPipeline/modal/prospectPanel/clientInformation/PregnancyAndBirthSection.vue